// extracted by mini-css-extract-plugin
module.exports = {"CollectionType__box":"CollectionType_CollectionType__box__3NAra","CollectionType__radio":"CollectionType_CollectionType__radio__9-skN"};